import RewardCard from '../../shared/RewardCard'
import styles from './styles.module.scss'

const ApplicationBenefits = (): JSX.Element => (
  <div className={styles.applicationBenefits}>
    <h3>受け取れる特典</h3>
    <RewardCard compact />
    <RewardCard store compact />
    <ul>
      <li>掲載開始の確認後にお支払い</li>
      <li>紹介できる店舗数に上限はありません</li>
      <li>導入の可否はecboより店舗へご連絡します</li>
    </ul>
  </div>
)

export default ApplicationBenefits
